module.exports = "/_next/static/images/car-fallback-71854cc48ea5e6e2aaf62b3215247ec5.svg";